// import { ref, onMounted } from "vue";
// import pkg from "../../package.json";

// const CHECK_INTERVAL_MINUTES = 30;

// export function useVersionChecker() {
//   const checkingVersion = ref(true);
//   const updateAvailable = ref(false);
//   const currentVersion = pkg.version;

//   const check = async () => {
//     try {
//       const res = await fetch(`/meta.json?t=${Date.now()}`, {
//         cache: "no-store",
//       });
//       const meta = await res.json();

//       const stored = localStorage.getItem("appVersion") || currentVersion;

//       if (meta.version !== stored) {
//         updateAvailable.value = true;
//       } else {
//         localStorage.setItem("appVersion", meta.version);
//       }
//     } catch (e) {
//       console.warn("Version check failed:", e);
//     } finally {
//       checkingVersion.value = false;
//     }
//   };

//   const refreshApp = () => {
//     localStorage.setItem("appVersion", Date.now());
//     window.location.reload();
//   };

//   onMounted(() => {
//     check();
//     setInterval(check, CHECK_INTERVAL_MINUTES * 60 * 1000);
//   });

//   return { updateAvailable, refreshApp, checkingVersion };
// }

// import { ref, onMounted } from "vue";
// import pkg from "../../package.json";

// const CHECK_INTERVAL_MINUTES = 5; // Shorter interval for quicker detection
// const STORAGE_KEY = "appVersion";

// export function useVersionChecker() {
//   const checkingVersion = ref(true);
//   const updateAvailable = ref(false);
//   const currentVersion = pkg.version;

//   const check = async () => {
//     try {
//       const res = await fetch(`/meta.json?t=${Date.now()}`, {
//         cache: "no-store",
//       });
//       const meta = await res.json();

//       const stored = localStorage.getItem(STORAGE_KEY);

//       // First visit or no stored version
//       if (!stored) {
//         localStorage.setItem(STORAGE_KEY, meta.version);
//         checkingVersion.value = false;
//         return;
//       }

//       // Detect a new deployment immediately
//       if (meta.version !== stored) {
//         updateAvailable.value = true;
//       } else {
//         updateAvailable.value = false;
//       }
//     } catch (e) {
//       console.warn("Version check failed:", e);
//     } finally {
//       checkingVersion.value = false;
//     }
//   };

//   const refreshApp = () => {
//     // Save the new version so banner won't show again
//     localStorage.setItem(STORAGE_KEY, currentVersion);

//     // Hard reload ensures all new chunks are loaded
//     window.location.reload(true);
//   };

//   // Run immediately to catch new deployments
//   onMounted(() => {
//     check();
//     setInterval(check, CHECK_INTERVAL_MINUTES * 60 * 1000);
//   });

//   return { updateAvailable, refreshApp, checkingVersion };
// }

// composables/useVersionChecker.ts
import { ref, onMounted } from "vue";
import pkg from "../../package.json";

const CHECK_INTERVAL_MINUTES = 5;
const STORAGE_KEY = "appVersion";

const globalUpdateAvailable = ref(false);
const globalCheckingVersion = ref(false);
let intervalId = null;

export function useVersionChecker() {
  const currentVersion = pkg.version;

  const check = async () => {
    try {
      globalCheckingVersion.value = true;

      const res = await fetch(`/meta.json?t=${Date.now()}`, {
        cache: "no-store",
      });

      if (!res.ok) {
        console.warn("Version check failed:", res.status);
        return;
      }

      const meta = await res.json();
      const stored = localStorage.getItem(STORAGE_KEY) || currentVersion;

      if (meta.version !== stored) {
        globalUpdateAvailable.value = true;
      }
    } catch (e) {
      console.warn("Version check failed:", e);
    } finally {
      globalCheckingVersion.value = false;
    }
  };

  const refreshApp = () => {
    localStorage.setItem(STORAGE_KEY, currentVersion);
    window.location.reload();
  };

  onMounted(() => {
    if (intervalId === null) {
      check(); // runs in background
      intervalId = window.setInterval(
        check,
        CHECK_INTERVAL_MINUTES * 60 * 1000
      );
    }
  });

  return {
    updateAvailable: globalUpdateAvailable,
    checkingVersion: globalCheckingVersion,
    refreshApp,
  };
}
